import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns1: []
    };
  },
  methods: {
    getColumns1() {
      let columns1 = [
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '业务员',
          align: 'center',
          key: 'userName',
          minWidth: 150,
          slot: 'userName_staffNo'
        },
        {
          title: '所属团队',
          align: 'center',
          key: 'groupName',
          minWidth: 160
        }
      ];
      // ok保
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        columns1.push({
          title: '结算主体',
          align: 'center',
          key: 'settlementEntity',
          render(h, params) {
            return <span>{params.row.settlementEntity || '-'}</span>;
          },
          minWidth: 160
        });
      }
      columns1 = columns1.concat([
        {
          title: '所属机构',
          align: 'center',
          key: 'orgName',
          minWidth: 160
        },
        {
          title: '总单量',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '基本法收益',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120
        },
        {
          title: '基本法外首期基础费用',
          align: 'center',
          key: 'baseFirstIncome',
          width: 170
        },
        {
          title: '基本法外续期基础费用',
          align: 'center',
          key: 'baseRenewalIncome',
          width: 160
        },
        {
          title: '首年后置费用',
          align: 'center',
          key: 'basePostfIncome',
          width: 160
        },
        {
          title: '无门槛限时加费',
          align: 'center',
          key: 'platformActivityIncome',
          width: 160,
          slot: 'platformActivity'
        }
      ]);
      // ok保
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        columns1 = columns1.concat([
          {
            title: '团队长首期管理费',
            align: 'center',
            key: 'baseFirstLeaderIncome',
            width: 160
          },
          {
            title: '团队长续期管理费',
            align: 'center',
            key: 'baseRenewalLeaderIncome',
            width: 160
          },
          {
            title: '团队长后置管理费',
            align: 'center',
            key: 'basePostfLeaderIncome',
            minWidth: 130
          }
        ]);
      }
      columns1 = columns1.concat([
        {
          title: '其他活动收益',
          align: 'center',
          key: 'activityIncome',
          minWidth: 120,
          slot: 'activity'
        },
        {
          title: '加扣款',
          align: 'center',
          key: 'deduction',
          minWidth: 120,
          slot: 'deductionAction'
        },
        {
          title: '税前合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 120
        },
        {
          title: '个税',
          align: 'center',
          key: 'tax',
          minWidth: 120
        }
      ]);
      // ok保
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        columns1 = columns1.concat([
          {
            title: '增值税',
            align: 'center',
            key: 'valueAddTax',
            minWidth: 130
          },
          {
            title: '附加税',
            align: 'center',
            key: 'additionalTax',
            minWidth: 130
          }
        ]);

        let idx = columns1.findIndex(i => i.key == 'baseRenewalIncome');
        if (idx != -1) {
          columns1.splice(++idx, 0, {
            title: '基本法扣款',
            align: 'center',
            key: 'methodDeductIncome',
            minWidth: 130
          });
        }
      }
      columns1 = columns1.concat([
        {
          title: '税后合计',
          align: 'center',
          key: 'costAmount',
          minWidth: 120
        },
        {
          title: '工资卡',
          align: 'center',
          key: 'cardNo',
          width: 180
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ]);
      this.columns = columns1;
    },
    getColumns2() {
      let columns2 = [
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 160
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 100
        },
        {
          title: '总单量',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '基本法收益',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120
        },
        {
          title: '基本法外首期基础费用',
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 160
        },
        {
          title: '基本法外续期基础费用',
          align: 'center',
          key: 'baseRenewalIncome',
          minWidth: 160
        },
        {
          title: '首年后置费用',
          align: 'center',
          key: 'basePostfIncome',
          minWidth: 180
        },
        {
          title: '无门槛限时加费',
          align: 'center',
          key: 'platformActivityIncome',
          width: 160,
          slot: 'platformActivity'
        }
      ];
      // ok保
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        columns2 = columns2.concat([
          {
            title: '团队长首期管理费',
            align: 'center',
            key: 'baseFirstLeaderIncome',
            minWidth: 180
          },
          {
            title: '团队长续期管理费',
            align: 'center',
            key: 'baseRenewalLeaderIncome',
            minWidth: 180
          },
          {
            title: '团队长后置管理费',
            align: 'center',
            key: 'basePostfLeaderIncome',
            minWidth: 130
          }
        ]);
      }
      columns2 = columns2.concat([
        {
          title: '其他活动收益',
          align: 'center',
          key: 'activityIncome',
          minWidth: 130,
          slot: 'activity'
        },
        {
          title: '加扣款',
          align: 'center',
          key: 'deduction',
          minWidth: 120,
          slot: 'deductionAction'
        },
        {
          title: '税前合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 130
        },
        {
          title: '个税',
          align: 'center',
          key: 'tax',
          minWidth: 130
        }
      ]);
      // ok保
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        columns2 = columns2.concat([
          {
            title: '增值税',
            align: 'center',
            key: 'valueAddTax',
            minWidth: 130
          },
          {
            title: '附加税',
            align: 'center',
            key: 'additionalTax',
            minWidth: 130
          }
        ]);
        
        let idx = columns2.findIndex(i => i.key == 'baseRenewalIncome');
        if (idx != -1) {
          columns2.splice(++idx, 0, {
            title: '基本法扣款',
            align: 'center',
            key: 'methodDeductIncome',
            minWidth: 130
          });
        }
      }
      columns2.push({
        title: '税后合计',
        align: 'center',
        key: 'costAmount',
        minWidth: 130
      });
      this.columns = columns2;
    }
  }
};
